import { gql } from 'graphql-tag'

export const fetchFileLinks = gql`
  query FetchFileLinks($stationId: ID!) {
    fileLinks {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
    favoriteFileLinks(stationId: $stationId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
  }
`

export const fetchAokFileLinks = gql`
  query FetchAokFileLinks($companyId: ID, $stationId: ID!) {
    aokFileLinks(companyId: $companyId) {
      id
      fileName
      href
      company {
        id
        name
      }
      linkTags {
        id
        name
      }
    }
    favoriteFileLinks(stationId: $stationId) {
      id
      fileName
      href
      linkTags {
        id
        name
      }
    }
  }
`

export const fetchFavoriteFileLinks = gql`
  query FetchFavoriteFileLinks($stationId: ID!) {
    favoriteFileLinks(stationId: $stationId) {
      id
      fileName
      href
    }
  }
`

export const toggleFavoriteFileLink = gql`
  mutation ToggleFavoriteFileLink($stationId: ID!, $id: ID!) {
    favoriteFileLink(stationId: $stationId, id: $id) {
      id
      fileName
      href
    }
  }
`
